<template>
  <div class="top-activity" @click="toLink" v-if="topShow"></div>
</template>
<script>
import { zhugeTrack } from "@/../public/public";
export default {
  name: "topActivity",
  data() {
    return {
      startTime: new Date("2021/5/10 00:00:00").getTime(),
      endTime: new Date("2021/5/31 23:59:59").getTime(),
    };
  },
  computed: {
    topShow() {
      let nowTime = new Date().getTime();
      if (this.startTime <= nowTime && nowTime < this.endTime) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    toLink() {
      window.open("https://www.boxuegu.com/subject/activity-28.html?utm_source=hckt");
      zhugeTrack("Web_回车课堂", {
        按钮名称: '首页顶浮'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.top-activity {
  cursor: pointer;
  width: 100%;
  height: 80px;
  min-width: 1260px;
  background: url('../../image/index/top-activity.png') no-repeat;
}
</style>